import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";
export const getSubjectData = createAsyncThunk("main/subject", async () => {
  return await apiInstance.get("/question/subject-wise-question-count", {
    headers: authHeader(),
  });
});

export const getAllSubjectData = createAsyncThunk(
  "subject/all",
  async ({ page, limit, classesFilter }) => {
    return await apiInstance.get(
      `/subject/all?page=${page}&limit=${limit}&classesFilter=${classesFilter}`,
      {
        headers: authHeader(),
      }
    );
  }
);
export const getFullLengthById = createAsyncThunk(
  "subject/getById",
  async ({ isFullLength }, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(
        `/subject?isFullLength=${isFullLength}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

const initialState = {
  staticData: [],
  subjectData: [],
  // fullLengthData: [],
};

const subjectSlice = createSlice({
  name: "subjectSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSubjectData.fulfilled, (state, action) => {
      state.staticData = action.payload.data;
    });
    builder.addCase(getAllSubjectData.fulfilled, (state, action) => {
      state.subjectData = action.payload.data;
    });
    builder.addCase(getFullLengthById.fulfilled, (state, action) => {
      state.fullLengthData = action.payload.data;
    });

  },
});
export default subjectSlice.reducer;

export const selectedStaticData = (state) => state.subject.staticData;
